import React, { useEffect } from "react";
import { useQuestionContext } from "lib/providers/questionProvider";
import { FormState } from "./SkipBags.validation";

interface LoadQueryParamsProps {
  queryParams: FormState;
}

export const LoadQueryParams = ({ queryParams }: LoadQueryParamsProps) => {
  const context = useQuestionContext<FormState>();

  useEffect(() => {
    if (typeof queryParams.type === "undefined") return;

    context.close("type");
    context.open(
      queryParams.type === "COLLECTIONONLYSKIPBAGS" ? "isPaid" : "products",
    );

    if (
      queryParams.type !== "COLLECTIONONLYSKIPBAGS" ||
      typeof queryParams.isPaid === "undefined"
    )
      return;

    context.close("isPaid");
    context.open(queryParams.isPaid === "Yes" ? "refAndPostcode" : "products");
  }, []);

  return null;
};
